import {
  CREATEORUPDATELOYALTYPOINT_SUCCESS,
  CREATEORUPDATELOYALTYPOINT_FAILED,
  RESET_CREATEORUPDATELOYALTYPOINT,
  LOADING_CREATEORUPDATELOYALTYPOINT,
  NETWORK_ERROR_CREATEORUPDATELOYALTYPOINT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetCreateOrUpdateLoyaltyPoint = () => {
  return { type: RESET_CREATEORUPDATELOYALTYPOINT };
};

const createOrUpdateLoyaltyPointReq =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_CREATEORUPDATELOYALTYPOINT });
    await partnerServices
      .post("createOrUpdateLoyaltyPoint", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(createOrUpdateLoyaltyPointSuccess(res.data));
            break;
          default:
            dispatch(createOrUpdateLoyaltyPointFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_CREATEORUPDATELOYALTYPOINT,
          payload: err,
        });
      });
  };
function createOrUpdateLoyaltyPointSuccess(data) {
  return {
    type: CREATEORUPDATELOYALTYPOINT_SUCCESS,
    payload: data,
  };
}
function createOrUpdateLoyaltyPointFailed(data) {
  return {
    type: CREATEORUPDATELOYALTYPOINT_FAILED,
    payload: data,
  };
}

export { resetCreateOrUpdateLoyaltyPoint, createOrUpdateLoyaltyPointReq };
